import React, {useEffect, useMemo, useState}		from 'react';

import Input										from '../ressources/components/Input';
import Icon											from '../ressources/components/Icon';
import Modal										from '../ressources/components/Modal';
import {DeviceCard, DeviceStatus}					from '../ressources/components/Device';
import {IconModalSave}								from '../ressources/components/Icon/preConfig';
import DeviceFilterModal							from '../ressources/components/ModalFilter';
import Badge										from '../ressources/components/Badge';
import Checkbox										from '../ressources/components/Checkbox';
import DeviceImage									from '../ressources/components/Device/DeviceImage';
import Select										from '../ressources/components/Select';
import Button										from '../ressources/components/Button';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {assignDevicesApi}							from '../redux/devices/devices';
import {InputValues}								from '../ressources/components/Input/interface';
import {Device}										from '../redux/devices/interface';
import {FilterChecked}								from '../ressources/components/Modal/interface';
import {User}										from '../redux/user/interface';
import {SelectData}									from '../ressources/components/Select/interface';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_formatUserName}							from '../ressources/functions/format';
import {ft_checkDeviceFilters}						from '../ressources/functions/filters';
import {ft_getDeviceName, ft_getDeviceStatus,
	ft_getDeviceType, ft_getDeviceTypeName}			from '../ressources/functions/deviceFunction';
import {ft_search}									from '../ressources/functions/search';

import img_search									from '../ressources/images/icon/search.svg';
import img_device									from '../ressources/images/icon/devices/computer.svg';
import img_usersRemove								from '../ressources/images/icon/users-remove.svg';
import img_refresh									from '../ressources/images/icon/refresh.svg';
import img_dotsVertical								from '../ressources/images/icon/dots-vertical.svg';

import LANGUAGE										from '../ressources/language';


interface Props {
	actualUser?: User | undefined,
	onClose?: () => void,
	modal?: boolean,
	runCheck?: number,
	onSave?: (selectedDevices: string[]) => void,
	onlyOneSelection?: boolean,
	onlyValalaDevice?: boolean,
	noValidation?: boolean,
	deviceList?: Device[],
	deleteAction?: (deviceId: string) => void,
	hideFilter?: boolean
}

interface ConfirmList {
	confirm: boolean,
	device: Device
}

function UsersModalAssignDevice(props: Props) {
	const dispatch = useAppDispatch();
	const devices = useAppSelector(state => state.devices.data);
	const mobileLines = useAppSelector(state => state.mobileLines.data);
	const load = useAppSelector(state => state.devices.isLoadAssign);
	const users = useAppSelector(state => state.companyUsers.data);
	const user = useAppSelector(state => state.user.data);
	const lang = useAppSelector(state => state.settings.lang);
	let notificationId = useAppSelector(state => state.notifications.lastId);

	const [search, set_search] = useState<InputValues>('');

	const [checkList, set_checkList] = useState<{[key: string]: boolean}>({});
	const [filters, set_filters] = useState<FilterChecked[]>([]);

	const [filterModal, set_filterModal] = useState(false);

	const [saveModal, set_saveModal] = useState(false);
	const [confirmList, set_confirmList] = useState<ConfirmList[]>([]);

	const TEXTE = LANGUAGE(lang);
	const ACTIONS_LIST: SelectData[] = [
		{
			value:  'delete',
			render: <span className={'text-xs weight-500 error-600'}>{TEXTE.global.delete}</span>
		}
	];

	const devicesWithLines = useMemo(() => [...devices, ...mobileLines], [devices, mobileLines]);

	const allFilters = useMemo(() => {
		const found: {[key: string]: SelectData[]} = {
			type:     [],
			status:   [],
			supplier: [],
			tags:     []
		};

		(props.deviceList || devicesWithLines).forEach((device) => {
			const type = ft_getDeviceType(device);
			const status = ft_getDeviceStatus(device, users);
			const supplier = device.notValala ? device.notValalaData?.funder : 'Valala';

			if (props.onlyValalaDevice && device.notValala)
				return;

			if (!found.type.find(find => find.value === type))
				found.type.push({value: type, render: ft_getDeviceTypeName(TEXTE, type)});
			if (!found.status.find(find => find.value === status))
				found.status.push({value: status, render: <DeviceStatus forceStatus={status} />});
			if (supplier && !found.supplier.find(find => find.value === supplier))
				found.supplier.push({value: supplier, render: supplier});

			device?.tags?.forEach((tag) => {
				if (!found.tags.find(find => find.value === tag))
					found.tags.push({value: tag, render: tag});
			});
		});

		return found;
	}, [devicesWithLines, props.deviceList]);

	useEffect(() => {
		if (props.runCheck && props.runCheck > 0)
			checkBeforeSave();
	}, [props.runCheck]);

	function saveAssign(list: ConfirmList[]) {
		const finalList = list.filter(filter => filter.confirm || props.noValidation);

		if (props.onSave)
			return props.onSave(finalList.map(data => data.device._id));
		if (!user || !props.actualUser)
			return;

		dispatch(assignDevicesApi({
			user,
			assignUser: props.actualUser,
			devicesId:  finalList.map(data => data.device._id)
		}))
		.then(() => {
			finalList.forEach((data) => {
				if (!data.device.user)
					return;
				const userData = users.find(find => find?._id === data.device.user);

				const notificationData = ft_genNotification(TEXTE, 'removeAssignDeviceSuccess', img_usersRemove, ft_formatUserName(userData));
				notificationId = ft_pushNotification(dispatch, notificationId, notificationData);
			});

			const notificationData = ft_genNotification(TEXTE, 'assignDeviceSuccess', img_device, ft_formatUserName(props.actualUser));
			ft_pushNotification(dispatch, notificationId, notificationData);

			if (props.onClose)
				props.onClose();
		});
	}

	function checkBeforeSave() {
		const toArray = Object.entries(checkList).filter(filter => filter[1]);
		const result: ConfirmList[] = [];
		let alreadyAssign = false;

		if (toArray.length === 0 && props.onClose)
			return props.onClose();
		if (toArray.length === 0)
			return props.onSave ? props.onSave([]) : null;

		toArray.forEach((checkedData) => {
			const deviceData = devicesWithLines.find(find => find?._id === checkedData[0]);

			if (deviceData?.user && users.some(find => find?._id === deviceData.user))
				alreadyAssign = true;

			if (deviceData) {
				result.push({
					device:  deviceData,
					confirm: !deviceData?.user || !!props.onlyOneSelection
				});
			}
		});

		if (!alreadyAssign || props.onlyOneSelection || props.noValidation)
			return saveAssign(result);
		set_confirmList(result);
		return set_saveModal(true);
	}

	function onChangeFilter(key: string, value: string) {
		const copy = [...filters];
		const index = copy.findIndex(find => find.key === key);

		if (index !== -1) {
			const indexValue = copy[index].values.findIndex(find => find === value);

			if (indexValue !== -1 && copy[index].values.length > 1)
				copy[index].values.splice(indexValue, 1);
			else if (indexValue !== -1)
				copy.splice(index, 1);
			else
				copy[index].values.push(value);
		} else
			copy.push({key, values: [value]});

		set_filters(copy);
	}

	function renderDevices() {
		const finalData = props.deviceList || devicesWithLines;
		const render: React.ReactElement[] = [];

		finalData.forEach((device) => {
			if (props.onlyValalaDevice && device.notValala)
				return;
			if ((props.actualUser && device.user === props.actualUser._id) || !ft_checkDeviceFilters(filters, device, users))
				return;
			if (search && !ft_search([device.name, device.serial], search as string, true, true))
				return;

			const userId = typeof(device.user) === 'string' ? device.user : device.user?._id;
			const renderTags:React.ReactElement[] = [];
			let deviceUser: User | undefined;

			device.tags?.forEach((tag) => {
				renderTags.push(
					<Badge size={'sm'} color={'gray'} text={tag} />
				);
			});

			if (userId)
				deviceUser = users.find(find => find?._id === userId);

			render.push(
				<tr
					className={`modalAssignTableRow ${checkList[device._id] && 'selected'}`}
					style={props.deleteAction && {cursor: 'default'}}
					onClick={() => !props.deleteAction && set_checkList({...(!props.onlyOneSelection && checkList), [device._id]: !checkList[device._id]})}
				>
					<td>
						<div>
							{!props.deleteAction &&
								<Checkbox round={props.onlyOneSelection} active={checkList[device._id]} />
							}
							<DeviceImage
								size={32}
								iconSize={14}
								device={device}
								imageFormat={'small'}
							/>
							<span className={'text-xs weight-500 gray-900'}>{ft_getDeviceName(device)}</span>
						</div>
					</td>
					<td>
						<DeviceStatus device={device} />
					</td>
					<td>
						<span className={'text-xs primary-600 weight-500'}>{ft_formatUserName(deviceUser)}</span>
					</td>
					<td>
						<div className={'modalAssignTags'}>
							{renderTags}
						</div>
					</td>
					<td>
						{device.serial}
					</td>
					<td>
						{device.notValalaData?.internalId}
					</td>
					{props.deleteAction &&
						<td>
							<Button
								absoluteRight
								absoluteHideIcon
								type={'tertiary-gray'}
								absolute={ACTIONS_LIST}
								onChangeAbsolute={() => (props.deleteAction ? props.deleteAction(device._id) : undefined)}
							>
								<Icon icon={img_dotsVertical} />
							</Button>
						</td>
					}
				</tr>
			);
		});

		return render;
	}

	function renderSelectFilter(name: string, placeholder: string) {
		if (allFilters[name].length <= 1)
			return;

		return (
			<Select
				notFullWidth
				data={allFilters[name]}
				placeholder={placeholder}
				placeholderClassname={'text-sm'}
				onClickCheckbox={value => onChangeFilter(name, value as string)}
				checkboxChecked={value => !!filters.find(find => find.key === name && find.values.find(findVal => findVal === value))}
			/>
		);
	}

	function renderSaveModal() {
		const render: React.ReactElement[] = [];
		let last: ConfirmList;

		confirmList.forEach((deviceData, i) => {
			if (deviceData.confirm && !deviceData.device.user)
				return;
			last = deviceData;

			render.push(
				<DeviceCard
					checkbox
					assignReadOnly
					device={deviceData.device}
					selected={deviceData.confirm}
					previousSelected={last.confirm}
					onClick={() => {
						confirmList[i].confirm = !confirmList[i].confirm;
						set_confirmList([...confirmList]);
					}}
				/>
			);
		});

		return (
			<Modal
				size={798}
				confirmLoad={load}
				header={<IconModalSave />}
				footerFlexDirection={'column-reverse'}
				cancelButton={() => set_saveModal(false)}
				confirmButton={() => saveAssign(confirmList)}
				confirmButtonText={TEXTE.users.modal.assingAgain}
				confirmButtonDisabled={!confirmList.some(data => data.device.user && data.confirm)}
				cancelButtonText={TEXTE.users.modal.cancelSelection}
			>
				<span className={'modalTitle'}>
					{TEXTE.users.modal.deviceAlreadyInUse}
				</span>

				<span>{TEXTE.users.modal.deviceAlreadyInUseText}</span>
				<br />

				<span className={'weight-600'}>{TEXTE.users.modal.selectDevice}</span>

				<div className={'usersModalAssignConfirm'}>
					{render}
				</div>
			</Modal>
		);
	}

	function renderContent() {
		return (
			<>
				{!props.hideFilter &&
					<Input
						value={search}
						onChange={val => set_search(val as string)}
						placeholder={TEXTE.devices.modal.typeAName}
						before={<Icon icon={img_search} />}
					/>
				}

				{!props.hideFilter &&
					<div className={'modalAssignTagsFilterContainer'}>
						{renderSelectFilter('type', TEXTE.global.type)}
						{renderSelectFilter('status', TEXTE.global.status)}
						{renderSelectFilter('supplier', TEXTE.global.supplier)}
						{renderSelectFilter('tags', TEXTE.global.tags)}

						{filters.length > 0 &&
							<Icon
								icon={img_refresh}
								onClick={() => set_filters([])}
							/>
						}
					</div>
				}

				<div className={'modalAssignTableContainer'}>
					<table className={'modalAssignTable'}>
						<thead>
							<tr style={{textAlign: 'left'}}>
								<th>{TEXTE.global.name}</th>
								<th>{TEXTE.global.state}</th>
								<th>{TEXTE.global.owner}</th>
								<th>{TEXTE.global.tags}</th>
								<th>{TEXTE.global.serial}</th>
								<th>{TEXTE.global.internalId}</th>
								{props.deleteAction && <th>{TEXTE.global.action}</th>}
							</tr>
						</thead>
						<tbody>
							{renderDevices()}
						</tbody>
					</table>
				</div>

				{filterModal &&
					<DeviceFilterModal
						filters={filters}
						setFilters={set_filters}
						onClose={() => set_filterModal(false)}
					/>
				}
				{saveModal && renderSaveModal()}
			</>
		);
	}

	if (!props.modal)
		return renderContent();

	return (
		<Modal
			fullWidth
			modalRight
			confirmLoad={load}
			confirmButton={checkBeforeSave}
			onClose={() => (props.onClose ? props.onClose() : null)}
			header={props.onlyOneSelection ? TEXTE.devices.selectOneDevice : TEXTE.users.setDevice}
			confirmButtonText={props.onlyOneSelection ? TEXTE.devices.chooseThisDevice : TEXTE.users.setDevices}
		>
			{renderContent()}
		</Modal>
	);
}

export default UsersModalAssignDevice;
